// extracted by mini-css-extract-plugin
export var container = "_4u-0";
export var disabled = "_4u-4";
export var fullWidth = "_4u-3";
export var lined = "_4u-1";
export var selected = "_4u-5";
export var tab = "_4u-2";